import { render, staticRenderFns } from "./OutroAdd.vue?vue&type=template&id=8242b5e8&"
import script from "./OutroAdd.vue?vue&type=script&lang=js&"
export * from "./OutroAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports